import home from '../components/home'
import detailed from '../components/detailed'
import collection from '../components/collection'
import relevant from '../components/relevant'
import helpCenter from '../components/helpCenter.vue'
import degree from '../pages/productInfo/index.vue';

const routes = [
  // {path:'/',redirect:'/home'},
  { path: '/fileCenter', component: home },    //文档库
  { path: '/detailed', component: detailed },
  { path: '/collection', component: collection },
  { path: '/relevant', component: relevant },
  { path: '/helpCenter', component: helpCenter },  //帮助中心
  {  //学位云产品介绍
    path: '/degree',
    component: degree,
  }
]
export default routes


// WEBPACK FOOTER //
// ./src/router/routes.js